import type { AttachBilletterieOrderData } from '@cpce/shared';
import { commiteeMutation, MutationMethod } from '@/api/mutations.utils';
import { employeesQueryKeys } from '../employees/employees.query-keys';
import { prestationsQueryKeys } from '../prestations/prestations.query-keys';
import { billetterieOrdersQueryKeys } from './billetterie-orders.query-keys';

export function useAttachBilletterieOrder() {
  return commiteeMutation<
    { participationId: number },
    AttachBilletterieOrderData,
    AttachBilletterieOrderData & { orderId: number }
  >({
    url: ({ orderId }) => `/commitee/:commiteeId/billetterie-orders/${orderId}/attach`,
    method: MutationMethod.POST,
    body: ({ checkoutCompletedAt, cardId }) => ({ checkoutCompletedAt, cardId }),
    successMessage: 'Commande rattachée à la comptabilité du CSE',
    invalidateQueries: [
      billetterieOrdersQueryKeys.all,
      employeesQueryKeys.all,
      prestationsQueryKeys.all,
    ],
  });
}
